import "./gender.scss";
import "./genderResponsive.sass";
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import { Hero } from "../../container/index";
import React, { useState } from "react";
import { News, Helm } from "../../components/index";
import { useEffect } from "react";
import { request } from "../../api/request";
import TomchiLogo from '../../assets/icons/TOMCHILOGO.png'
import { useDispatch } from "react-redux";
import { set_data } from "../../redux/action";
import { useSelector } from "react-redux";
import parser from "html-react-parser";
import QRcode from '../../assets/qrCode.png'
const GenderHikoya = () => {

    const dispatch = useDispatch();

    const event = useSelector((state) => state.data.data);
    const lang = useSelector((state) => state.data.lang);
    const news = useSelector(state => state.data.news)
    const [categories, setCategories] = useState([])

    const [active, setActive] = useState(0)

    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        request
            .get(`/content/all/event?sort=DESC&sortby=id&lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => dispatch(set_data(res.data)))
            .catch((err) => console.log(err));

        request
            .get(`/segment/all/event_category?lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));
    }, [lang]);
    return (
        <div className="events-page">
            {/*<Helm id={"37"}/>*/}

            <div className="hero-page">
                <Hero
                    id={"663"}
                    nameOne={
                        lang === "uz"
                            ? "Bosh sahifa"
                            : lang === "ru"
                                ? "Домой"
                                : lang === "en"
                                    ? "Home page"
                                    : ""
                    }
                    nameTwo={
                        lang === "uz"
                            ? "Gender konsepsiyasi"
                            : lang === "ru"
                                ? "Открытые данные"
                                : lang === "en"
                                    ? "Open data"
                                    : ""
                    }
                    linkOne={"/"}
                    linkTwo={"/gender-konsepsiya"}
                />
            </div>

            <div className="inner-pages container">
                <div className="col-one">
                    <div className="heading">
                        <h1 className="news-holder">Kategoriya</h1>
                    </div>
                    <div className="events-category">
                        <button
                            onClick={() => history.push('/gender-konsepsiya')}
                            className={currentPath === '/gender-konsepsiya' ? 'active' : ''}
                        >
                            Gender konsepsiyasi
                        </button>
                        <button
                            onClick={() => history.push('/gender-material')}
                            className={currentPath === '/gender-material' ? 'active' : ''}
                        >
                            Rasmiy taqdimot materiallari
                        </button>
                        <button
                            onClick={() => history.push('/gender-hikoya')}
                            className={currentPath === '/gender-hikoya' ? 'active' : ''}
                        >
                            Loyiha hikoyalari
                        </button>
                    </div>
                    <div className="tomchi">
                        <img src={QRcode} alt=""/>
                    </div>
                    <div className="tomchi-links">
                        <img src={TomchiLogo} alt=""/>
                        <h3 style={{
                            fontSize: '13px'
                        }} className='tomchi-title'>QR code skanerlang va Tomchi mobil ilovasini yuklab oling.</h3>
                    </div>
                </div>

                <div className="col-two">
                    <div className="heading">
                        <h1 className="news-holder">Suv xo'jaligida gender konsepsiyasi</h1>
                    </div>

                    <a href="/gender-hikoya-1" className="section-card">
                        <div className="left-side">
                            <div className="date">
                                <img src="Date" alt=""/>
                                <span>24.06.2025</span>
                            </div>
                            <img className="bg-image"
                                 src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot9.webp" alt="NoPhoto"/>
                        </div>
                        <div className="right-side">
                            <h2 className="{region ? 'region-title' : ''}">
                                Suv va tenglik uchun yangi bosqich: O‘zbekistonning 2025–2030 yillarga mo‘ljallangan
                                Gender konsepsiyasi bilan mening sayohatim
                            </h2>
                        </div>
                    </a>
                    <a href="/gender-hikoya-2" className="section-card">
                        <div className="left-side">
                            <div className="date">
                                <img src="Date" alt=""/>
                                <span>24.06.2025</span>
                            </div>
                            <img className="bg-image"
                                 src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot1.webp" alt="NoPhoto"/>
                        </div>
                        <div className="right-side">
                            <h2 className="{region ? 'region-title' : ''}">
                                "Daryo bir tomchidan boshlanadi: suv sohasida teng imkoniyatlar sari yo‘lim"
                            </h2>
                        </div>
                    </a>


                </div>

                <div className="col-thr">
                    <h1 className="news-holder">
                        {lang === "uz"
                            ? "So’ngi yangiliklar"
                            : lang === "ru"
                                ? "последние новости"
                                : lang === "en"
                                    ? "Last news"
                                    : ""}
                    </h1>
                    {news && news.status === 1 ? (
                        news.data &&
                        news.data.map((el, index) => (
                            <News
                                date={el.created_on}
                                key={index}
                                title={el.title}
                                id={el.id}
                            />
                        ))
                    ) : (
                        <h1>Loading ...</h1>
                    )}
                </div>
            </div>

            <div className="margin"></div>
        </div>
    );
};

export default GenderHikoya;
